import { OfferType } from 'constants/enums';

import { RadioButtonOptionsProps } from '../../../components/RadioButton/RadioButton';

export enum EPagesRadioButtonOptions {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
  SCHEDULED = 'scheduled'
}

export enum EPagesTemplateOptions {
  CONTENT = 'content',
  STORE = 'store',
  HOME = 'home'
}

export enum EPageState {
  SETTINGS = 'settings',
  MANAGE_BLOCKS = 'manage-blocks'
}

export const pageTemplateOptions = [
  {
    value: EPagesTemplateOptions.CONTENT,
    label: EPagesTemplateOptions.CONTENT
  },
  {
    value: EPagesTemplateOptions.STORE,
    label: EPagesTemplateOptions.STORE,
    disabled: true
  },
  {
    value: EPagesTemplateOptions.HOME,
    label: EPagesTemplateOptions.HOME,
    disabled: true
  }
];

export enum EPagesVisibilityOptions {
  PUBLIC = 'public',
  SEGMENTED = 'segmented'
}

export const visibilityOptions = [
  {
    value: EPagesVisibilityOptions.PUBLIC,
    label: EPagesVisibilityOptions.PUBLIC
  },
  {
    value: EPagesVisibilityOptions.SEGMENTED,
    label: EPagesVisibilityOptions.SEGMENTED
  }
];

export const PAGES_RADIO_BUTTON_OPTIONS: RadioButtonOptionsProps[] = [
  {
    value: EPagesRadioButtonOptions.VISIBLE,
    id: EPagesRadioButtonOptions.VISIBLE,
    label: 'Visible'
  },
  {
    value: EPagesRadioButtonOptions.HIDDEN,
    id: EPagesRadioButtonOptions.HIDDEN,
    label: 'Hidden'
  }
];

export const PAGES_LEVEL_OPTIONS = [
  {
    value: 'false',
    id: 'false',
    label: 'Main Page'
  },
  {
    value: 'true',
    id: 'true',
    label: 'Sub Page'
  }
];

// BLOCKS

export interface IBlockItemFormProps {
  item: IBlockItem;
  blockIndex: number;
  itemIndex: number;
}

export type BlockType =
  | EBlockType.IMAGE
  | EBlockType.VIDEO
  | EBlockType.CTA
  | EBlockType.HTML
  | EBlockType.CONTENTS_PREVIEW
  | EBlockType.DAILY_BONUS
  | EBlockType.PROGRESS_BAR
  | EBlockType.OFFER;

export interface BaseItem {
  type: BlockType;
}

export interface IImageItem extends BaseItem {
  type: EBlockType.IMAGE;
  url: string;
  mobileUrl?: string;
  redirectUrl?: string;
}

export interface IVideoItem extends BaseItem {
  type: EBlockType.VIDEO;
  url: string;
  mobileUrl?: string;
  autoplay: boolean;
}

export interface ICtaItem extends BaseItem {
  type: EBlockType.CTA;
  redirectUrl: string;
  isStoreRedirect?: boolean;
  text?: string;
  assetUrl?: string;
  assetUrlMobile?: string;
}

export enum EBlockType {
  IMAGE = 'image',
  VIDEO = 'video',
  CONTENTS_PREVIEW = 'contentsPreview',
  CTA = 'cta',
  HTML = 'html',
  DAILY_BONUS = 'dailyBonus',
  PROGRESS_BAR = 'progressBar',
  OFFER = 'offer'
}

export enum EItemBlockType {
  IMAGE = 'image',
  VIDEO = 'video',
  CTA = 'cta'
}

export enum EContentType {
  ARTICLE = 'article',
  NEWS = 'news'
}

export type IBlockItem = IImageItem | IVideoItem | ICtaItem;

export type IBlock =
  | IRegularBlock
  | IHtmlBlock
  | IContentsPreviewBlock
  | IDailyBonusBlock
  | IProgressBarBlock
  | IOfferBlock;

export interface IBaseBlock {
  type: BlockType;
  itemsPerRow: number;
}

export interface IHtmlBlock extends IBaseBlock {
  type: EBlockType.HTML;
  html: string;
}

export interface IContentsPreviewBlock extends IBaseBlock {
  type: EBlockType.CONTENTS_PREVIEW;
  contentType: EContentType.ARTICLE | EContentType.NEWS;
  title: string;
  maxItems: number;
}

export interface IDailyBonusBlock extends IBaseBlock {
  type: EBlockType.DAILY_BONUS;
  backgroundImage?: string;
  backgroundImageMobile?: string;
  isStoreRedirect?: boolean;
  redirectUrl?: string;
}

export interface IProgressBarBlock extends IBaseBlock {
  type: EBlockType.PROGRESS_BAR;
  backgroundImage?: string;
  backgroundImageMobile?: string;
  isStoreRedirect?: boolean;
  redirectUrl?: string;
}

export interface IOfferBlock extends IBaseBlock {
  type: EBlockType.OFFER;
  offerType: OfferType.BUNDLE | OfferType.SPECIAL_OFFER | OfferType.ROLLING_OFFER;
  offerIds: string[];
}

export interface IRegularBlock extends IBaseBlock {
  type: EBlockType.IMAGE | EBlockType.VIDEO | EBlockType.CTA;
  items: IBlockItem[];
}

export interface IBlockContentProps {
  blockIndex: number;
  block: IBlock;
}

export const ERROR_FIELD_CLASS =
  'error-field mb-0 border border-base-destructive rounded-md border-solid';
